import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";

class MetricCtrTrivagoSL extends MetricBase {
    constructor() {
        super({
            field: "metric_ctr",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago_sl.ctr.chartName"),
            serieLabel: i18n.t("metrics.trivago_sl.ctr.serieLabel"),
            tooltip: i18n.t("metrics.trivago_sl.ctr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricCtrTrivagoSL;
